import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTab1Success,
  fetchTab1Failure,
  fetchTab2Success,
  fetchTab2Failure,
  updateTab2filters,
  insightTypes,
} from "../actions/insight";
import {
  fetchLocationEndPoint,
  //fetchv1DeviceDetailsEndPoint,
  fetchInsightReporting,
  fetchInsights,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

function* fetchInsightTab1Saga() {
  if(!sessionStorage.getItem("accountId")) return;
  try {
    const insightResponse = yield all([
      call(fetchLocationAPI),
      call(fetchInsightReportAPI),
    ]);

    const locations = insightResponse[0].filter(
      (loc) =>
        loc.tags && loc.tags.length > 0 && loc.tags[0].kind === "ts.tag.site"
    );

    let assets = locations.map((loc) => ({
      key: loc.id,
      name: loc.tags[0].name,
      orgId: loc.tags[0].orgId,
      orgName: loc.tags[0].org_name,
      prod: [0, 0],
      idle: [0, 0],
    }));

    // const deviceResponse = yield all([
    //   call(
    //     fetchDeviceAPI,
    //     "CAN",
    //     "PRODUCTIVE",
    //     assets.map((asset) => asset.key)
    //   ),
    //   call(
    //     fetchDeviceAPI,
    //     "CAN",
    //     "UNPRODUCTIVE",
    //     assets.map((asset) => asset.key)
    //   ),
    //   call(
    //     fetchDeviceAPI,
    //     "HOSE",
    //     "PRODUCTIVE",
    //     assets.map((asset) => asset.key)
    //   ),
    //   call(
    //     fetchDeviceAPI,
    //     "HOSE",
    //     "UNPRODUCTIVE",
    //     assets.map((asset) => asset.key)
    //   ),
    // ]);
    // let totalDevices = {
    //   key: "totalKey",
    //   name: "TOTAL",
    //   orgId: "",
    //   orgName: "",
    //   prod: [0, 0],
    //   idle: [0, 0],
    // };
    // for (let [index, asset] of assets.entries()) {
    //   const prodFull = deviceResponse[0].devices.filter(
    //     (device) => device.customdata.siteId === asset.key
    //   ).length;
    //   const prodEmpty = deviceResponse[1].devices.filter(
    //     (device) => device.customdata.siteId === asset.key
    //   ).length;
    //   const idleClean = deviceResponse[2].devices.filter(
    //     (device) => device.customdata.siteId === asset.key
    //   ).length;
    //   const idleUsed = deviceResponse[3].devices.filter(
    //     (device) => device.customdata.siteId === asset.key
    //   ).length;
    //   assets[index] = {
    //     ...assets[index],
    //     prod: [prodFull, prodEmpty],
    //     idle: [idleClean, idleUsed],
    //   };

    //   totalDevices = {
    //     ...totalDevices,
    //     prod: [
    //       totalDevices.prod[0] + prodFull,
    //       totalDevices.prod[1] + prodEmpty,
    //     ],
    //     idle: [
    //       totalDevices.idle[0] + idleClean,
    //       totalDevices.idle[1] + idleUsed,
    //     ],
    //   };
    // }

    // assets.push(totalDevices);
    // assets.unshift({
    //   key: "intialKey",
    //   name: "",
    //   orgId: "",
    //   orgName: "",
    //   prod: ["Full", "Empty"],
    //   idle: ["Clean", "Used"],
    // });

    const reportingHistoryData = insightResponse[1].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    );

    let reportingHistory = {
      date: [],
      gatewayCount: [],
      avgBattery: [],
    };

    for (let report of reportingHistoryData) {
      reportingHistory.date.push(
        `${new Date(report.date).getFullYear()}-${
          new Date(report.date).getMonth() + 1
        }-${new Date(report.date).getDate()}`
      );
      if (report?.onlinedevicecount) {
        reportingHistory.gatewayCount.push(report.onlinedevicecount);
      }

      if (report?.averagebatterypercentage) {
        reportingHistory.avgBattery.push(report.averagebatterypercentage);
      }
    }

    yield put(
      fetchTab1Success({
        locations,
        data: {
          assets: assets,
          reporting: {
            gatewayCount:
              reportingHistoryData.length > 1
                ? reportingHistoryData[1].onlinedevicecount
                : reportingHistoryData[0].onlinedevicecount,
            avgBattery:
              reportingHistoryData.length > 1
                ? reportingHistoryData[1].averagebatterypercentage
                : reportingHistoryData[0].averagebatterypercentage,
            percentageonline:
              reportingHistoryData.length > 1
                ? reportingHistoryData[1].percentageonline
                : reportingHistoryData[0].percentageonline,
          },
          reportingHistory: reportingHistory,
        },
      })
    );
  } catch (error) {
    console.log(error);
    yield put(fetchTab1Failure(error.message));
  }
}

async function fetchLocationAPI() {
  const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  });

  if (!response.ok) throw new Error("Something went wrong");
  return response.json();
}

async function fetchInsightReportAPI() {
  const response = await fetch(fetchInsightReporting(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountname: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "date", order: "desc" }] },
    }),
  });

  if (!response.ok) throw new Error("Something went wrong");

  return response.json();
}

async function fetchInsightsAPI(
  filters = {
    startDate: null,
    endDate: null,
    assettype: null,
  }
) {
  const { startDate, endDate, assettype } = filters;

  const response = await fetch(fetchInsights(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      startDate: startDate,
      endDate: endDate,
      assettype: assettype,
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

//  This function is currently not in use, when using this in future read below comments
//  Kindly note "fetchv1DeviceDetailsEndPoint" end point has been switched from V2 to V1,
//  when using this function kindly take care of making payload related changes
// async function fetchDeviceAPI(assetType, productiveStatus, tagIds = []) {
//   if (!Array.isArray(tagIds)) throw new Error("tagIds should be array");
//   const tagId = tagIds
//     .map((tagId) => `($/customdata/siteId eq '${tagId}')`)
//     .join(" OR ");
//   const response = await fetch(fetchv1DeviceDetailsEndPoint(), {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
//       "VZ-M2M-Token": getRandomUUID(),
//     },
//     body: JSON.stringify({
//       accountname: sessionStorage.getItem("accountId"),
//       $filter: `${tagId} AND ($/customdata/assetType eq '${assetType}') AND ($/customdata/productiveStatus eq '${productiveStatus}')`,
//     }),
//   });

//   if (!response.ok) throw new Error("Something went wrong");

//   return response.json();
// }

function* fetchInsightTab2Saga(action) {
  if(!sessionStorage.getItem("accountId")) return;
  try {
    let locations = action.payload.locations;
    let filters = action.payload.filters;

    let insights;
    let insightResponse;
    updateTab2filters(filters);

    if (locations.length > 0) {
      insightResponse = yield all([call(fetchInsightsAPI, filters)]);
    } else {
      insightResponse = yield all([
        call(fetchInsightsAPI, filters),
        call(fetchLocationAPI),
      ]);

      locations = insightResponse[1].filter(
        (loc) =>
          loc.tags && loc.tags.length > 0 && loc.tags[0].kind === "ts.tag.site"
      );
    }

    let uniqueLocations = [
      ...new Set(
        insightResponse[0].map((element) =>
          element["Location Name"]?.toLowerCase()
        )
      ),
    ];

    if (uniqueLocations.length > 0) {
      insights = locations
        .filter(
          (loc) =>
            uniqueLocations.includes(loc.tags[0].loc_type?.toLowerCase()) ||
            uniqueLocations.includes(loc.tags[0].name?.toLowerCase())
        )
        .map((loc) => {
          const avgDataResponse = insightResponse[0].filter(
            (response) =>
              (response["Location Name"]?.toLowerCase() ===
                loc.tags[0].loc_type?.toLowerCase() ||
                response["Location Name"]?.toLowerCase() ===
                  loc.tags[0].name?.toLowerCase()) &&
              response["Date Range"] === "Default"
          );

          const graphDataResponse = insightResponse[0].filter(
            (response) =>
              (response["Location Name"]?.toLowerCase() ===
                loc.tags[0].loc_type.toLowerCase() ||
                response["Location Name"]?.toLowerCase() ===
                  loc.tags[0].name?.toLowerCase()) &&
              response["Date Range"] !== "Default"
          );

          let avgData = {
            avgTotalDays: {
              value: 0.0,
              percentage: null,
            },
            avgDayAtDC: {
              value: 0.0,
              percentage: null,
            },
            avgDayAtYard: {
              value: 0.0,
              percentage: null,
              timeAtYardInbound: 0.0,
              timeAtYardOutbound: 0.0,
            },
            avgDayInTransit: {
              value: 0.0,
              percentage: null,
              timeDepartedPlant: 0.0,
              timeDepartedDC: 0.0,
              timeDepartedYardInbound: 0.0,
              timeDepartedYardOutbound: 0.0,
            },
            avgDayCycleCount: {
              value: 0.0,
              percentage: null,
            },
          };

          if (avgDataResponse.length > 0) {
            avgData = {
              ...avgData,
              avgTotalDays: {
                ...avgData.avgTotalDays,
                value: avgDataResponse[0]["AVG TOTAL_DAYS"],
              },
              avgDayAtDC: {
                ...avgData.avgDayAtDC,
                value: avgDataResponse[0]["AVG DAYS AT DC"],
              },
              avgDayAtYard: {
                ...avgData.avgDayAtYard,
                value: avgDataResponse[0]["AVG DAYS AT YARD"],
                timeAtYardInbound:
                  avgDataResponse[0]["Time at Yard Inbound"],
                timeAtYardOutbound:
                  avgDataResponse[0]["Time at Yard Outbound"],
              },
              avgDayInTransit: {
                ...avgData.avgDayInTransit,
                value: avgDataResponse[0]["AVG DAYS IN TRANSIT"],
                timeDepartedPlant: avgDataResponse[0]["Time Departed Plant"],
                timeDepartedDC: avgDataResponse[0]["Time Departed DC"],
                timeAtYardInbound: avgDataResponse[0]["Time Departed Yard Inbound"],
                timeAtYardOutbound: avgDataResponse[0]["Time Departed Yard Outbound"],
              },
              avgDayCycleCount: {
                ...avgData.avgDayCycleCount,
                value: avgDataResponse[0]["AVG CYCLE COUNT"],
              },
            };
          }

          let data = [];

          if (graphDataResponse.length > 0) {
            data = graphDataResponse.map((graphData) => ({
              date: graphData["Date Range"],
              timeDepartedPlant: parseFloat(graphData["Time Departed Plant"]),
              timeAtDC: parseFloat(graphData["Time Departed DC"]),
              timeTotal:
               (parseFloat(graphData["Time Departed Plant"]) +
                parseFloat(graphData["Time Departed DC"])+parseFloat(graphData["Time Departed Yard Inbound"]) +
                parseFloat(graphData["Time Departed Yard Outbound"])+parseFloat(graphData["Time at Yard Inbound"]) +
                parseFloat(graphData["Time at Yard Outbound"])).toFixed(2),
              gatewayCount: parseFloat(graphData["AVG CYCLE COUNT"]),
            }));
          }

          return {
            key: loc.id,
            locationName: loc.tags[0].name,
            ...avgData,
            data,
          };
        });
    } else {
      const startDate = new Date(filters.startDate);

      insights = locations.map((loc) => {
        let avgData = {
          avgTotalDays: {
            value: "0.00",
            percentage: null,
          },
          avgDayAtDC: {
            value: "0.00",
            percentage: null,
          },
          avgDayAtYard: {
            value: "0.00",
            percentage: null,
          },
          avgDayInTransit: {
            value: "0.00",
            percentage: null,
          },
          avgDayCycleCount: {
            value: "0.00",
            percentage: null,
          },
        };

        return {
          key: loc.id,
          locationName: loc.tags[0].name,
          ...avgData,
          data: [...Array(7)].map((data, index) => {
            startDate.setDate(startDate.getDate() + index);
            return {
              date: `${startDate.getFullYear()}-${(startDate.getMonth() + 1)
                .toString()
                .padStart(2, "0")}-${startDate
                .getDate()
                .toString()
                .padStart(2, "0")}`,
              timeDepartedPlant: 0.0,
              timeAtDC: 0.0,
              timeTotal: 0.0,
              gatewayCount: 0,
            };
          }),
        };
      });
    }

    yield put(fetchTab2Success(insights));
  } catch (error) {
    console.log(error);
    yield put(fetchTab2Failure(error.message));
  }
}

export function* FetchInsightTab1Saga() {
  yield takeLatest(insightTypes.FETCH_TAB1_REQUEST, fetchInsightTab1Saga);
}

export function* FetchInsightTab2Saga() {
  yield takeLatest(insightTypes.FETCH_TAB2_REQUEST, fetchInsightTab2Saga);
}
